export default __webpack_public_path__ + "static/media/Thermo Fisher Scientific.8ca2f86b.png";